import { Page } from '@frontend/components';
import { Header } from '@frontend/header-navigation';
import { useTranslation } from '@frontend/i18n';
import { DraftsList } from '../components/drafts-list/drafts-list';

export const Drafts = () => {
  const { t } = useTranslation('bulk-messaging');

  // TODO: Update to new Page component
  return (
    <Page
      title={<Header title={t('Drafts')} />}
      subtitle={t(
        'Get the word out quick! Create the perfect campaign to keep your patients returning time and time again.'
      )}
    >
      <DraftsList />
    </Page>
  );
};
